var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgColor = function SvgColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.298 6.97a.75.75 0 0 1 1.06 0l10.078 10.078a.75.75 0 0 1 0 1.06l-9.022 9.023a2.26 2.26 0 0 1-3.172 0l-.004-.004-7.963-7.963a2.26 2.26 0 0 1 0-3.172l.004-.004 9.019-9.018Zm-7.956 10.077a.76.76 0 0 0 0 1.063l.002.001 7.951 7.952.002.001a.76.76 0 0 0 1.062 0l.002-.001 8.484-8.485-9.017-9.017-8.486 8.486Z",
    fill: "#3D4043"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.625 15.75a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25ZM19 16.875a2.625 2.625 0 1 1 5.25 0 2.625 2.625 0 0 1-5.25 0ZM31.905 20.845l-.53.53-.53-.53a.75.75 0 0 1 1.06 0Zm-.53 1.681c.1.13.207.277.314.437.443.666.811 1.45.811 2.162a1.125 1.125 0 1 1-2.25 0c0-.712.368-1.496.811-2.162.107-.16.214-.307.314-.437Zm0-1.151-.53-.53-.002.001-.002.002-.006.006-.02.02a6.39 6.39 0 0 0-.302.335c-.19.222-.445.54-.7.922-.493.74-1.063 1.831-1.063 2.994a2.625 2.625 0 0 0 5.25 0c0-1.163-.57-2.254-1.063-2.994a9.703 9.703 0 0 0-1.002-1.256l-.02-.02-.006-.007-.002-.002h-.001l-.531.529Z",
    fill: "#3D4043"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.022 8.272a.75.75 0 0 1 1.061 0l6.75 6.75a.75.75 0 0 1-1.06 1.061l-6.75-6.75a.75.75 0 0 1 0-1.06Z",
    fill: "#3D4043"
  })));
};
export default SvgColor;